import type { Dispatch, PropsWithChildren, SetStateAction } from 'react';
import { createContext, useMemo, useState } from 'react';

interface StylesConfigContextParams {
  mobileFooter?: string;
}

// eslint-disable-next-line react-refresh/only-export-components
export const StylesConfigContext = createContext<null | {
  setStyles: Dispatch<SetStateAction<StylesConfigContextParams | undefined>>;
  styles?: StylesConfigContextParams;
}>(null);

const StylesConfigContextWrapper = ({ children }: PropsWithChildren) => {
  const [styles, setStyles] = useState<StylesConfigContextParams>();

  const value = useMemo(
    () => ({
      setStyles,
      styles,
    }),
    [styles]
  );

  return <StylesConfigContext.Provider value={value}>{children}</StylesConfigContext.Provider>;
};

export default StylesConfigContextWrapper;
